import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useTitle } from '@vueuse/core'
    import { reactive, onMounted } from 'vue'
    import { useChatStore } from '@/stores/chat'
    import { useUsersStore } from '@/stores/users'
    import { useMessageStore } from '@/stores/messages'
    import { useGroupsStore } from '@/stores/groups'
    import useIframeControl from '@/hooks/iframeInternalChat'

    import ErrorBox from './ErrorBox.vue'
    import MountedBox from './MountedBox.vue'

    type Component = 'MountedBox' | 'ErrorBox'

    type State = {
        component: Component
        hasError: Error | null
        open: boolean
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeBox',
  setup(__props) {

    const components = {
        MountedBox,
        ErrorBox
    }

    const iframe = useIframeControl()
    const chatStore = useChatStore()
    const userStore = useUsersStore()
    const groupStore = useGroupsStore()
    const messageStore = useMessageStore()

    useTitle('Chat Interno ')

    const state = reactive<State>({
        component: 'MountedBox',
        open: false,
        hasError: null
    })

    function initializeMessages(): void {
        const users : number[] = userStore.all.map(item => item.id)
        const groups : number[] = groupStore.all.map(item => item.id)
        messageStore.initialize(users, groups)
    }

    async function handleMountChat() {
        try {
            const response = await chatStore.initialize()
            if (!response.errors) {
                initializeMessages()
                state.open = true
            } else {
                console.error(response)
                throw response.errors
            }
        } catch (error) {
            handleError(error as Error)
        }
    }

    function handleError(error: Error) {
        if (error.message === 'parament not informed') {
            state.open = false
        }
        state.hasError = error
        state.component = 'ErrorBox'
    }

    onMounted(async () => {
        iframe.updateCoreValuesOnStore()
        await handleMountChat()
    })


return (_ctx: any,_cache: any) => {
  return (state.open)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(components[state.component]), {
        key: state.component
      }))
    : _createCommentVNode("", true)
}
}

})